// extracted by mini-css-extract-plugin
export default {"button":"style_button__5eGW2","text":"style_text__vgQ4g","textMobile":"style_textMobile__b4nDw"};